import React, { useRef, useState } from "react";
import { View, Text, Image } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import timeStampToTime from "../../common/DateExtension";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { AppImages } from "../../utility/AppImages";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";
import { formatTimestamp } from "../formatTimestamp";
import { TouchableOpacity } from "react-native";
import { Dimensions } from "react-native";
import MessageOnClickModal from "../chat-common-components/MessageOnClickModal";

const ChatModalMessageBubble = ({
  message,
  item,
  isSender,
  timestamp,
  isRead,
  user,
  currentChat,
  handleDeletePress,
  selectionMode,
  selectedMessages,
  setSelectedMessages,
}) => {
  const [showPopup, setShowPopup] = useState(false);

  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

  const messageRef = useRef(null);

  const handleLongPress = () => {
    if (!selectionMode) {
      setSelectedMessages([...selectedMessages, item.messageId]);
      messageRef.current.measureInWindow((x, y, width, height) => {
        const screenHeight = Dimensions.get("window").height;
        const popupTopPosition = y + height + 5;
        const popupLeftPosition = isSender ? x + width - 120 : x;
        setPopupPosition({
          top: Math.min(popupTopPosition, screenHeight - 150),
          left: popupLeftPosition,
        });
        setShowPopup(true);
      });
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const styles = useStyles();
  return (
    <>
      {isSender ? (
        <TouchableOpacity
          ref={messageRef}
          onLongPress={handleLongPress}
          activeOpacity={1}
        >
          <View style={{ alignSelf: "flex-end", marginStart: "35%" }}>
            <View style={styles.senderChatWrapper}>
              <View>
                <Text
                  style={[
                    AppFontStyle.MEDIUM_ANYBODY_14,
                    { paddingBottom: 5, maxWidth: 250 },
                  ]}
                >
                  {message}
                </Text>
              </View>
              <View style={{ alignSelf: "flex-end" }}>
                <View style={styles.timestampWrapper}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      {
                        color: "rgba(255, 255, 255, 0.50)",
                        textTransform: "capitalize",
                        paddingBottom: 5,
                        marginLeft: 25,
                        minWidth: 50,
                      },
                    ]}
                  >
                    {formatTimestamp(timestamp)}
                  </Text>
                  <Image
                    source={isRead ? AppImages.icnGreenTick : AppImages.icTick}
                    style={styles.tickIcon}
                    resizeMode="contain"
                  />
                </View>
              </View>
            </View>
          </View>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          ref={messageRef}
          onLongPress={handleLongPress}
          activeOpacity={1}
        >
          <View style={styles.receiverWrapper}>
            <View style={styles.receiverChatWrapper}>
              <View>
                {currentChat.type === "group" && (
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      {
                        color: AppColors.purpleColor_9D2CF5,
                        paddingBottom: 10,
                      },
                    ]}
                  >
                    {user}
                  </Text>
                )}
                <Text
                  style={[
                    AppFontStyle.MEDIUM_ANYBODY_14,
                    {
                      color: "#1D072D",
                      paddingBottom: 5,
                      maxWidth: 250,
                    },
                  ]}
                >
                  {message}
                </Text>
              </View>
              <View style={{ alignSelf: "flex-end" }}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    {
                      color: "rgba(0, 0, 0, 0.50)",
                      textTransform: "capitalize",
                      paddingBottom: 5,
                      marginLeft: 25,
                      minWidth: 50,
                    },
                  ]}
                >
                  {formatTimestamp(timestamp)}
                </Text>
              </View>
            </View>
          </View>
        </TouchableOpacity>
      )}
      {showPopup && (
        <MessageOnClickModal
          showPopup={showPopup}
          handleClosePopup={handleClosePopup}
          popupPosition={popupPosition}
          messageContent={message.messageContent}
          onDeletePress={handleDeletePress}
        />
      )}
    </>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    senderChatWrapper: {
      paddingHorizontal: 12,
      paddingTop: 10,
      borderRadius: 2,
      backgroundColor: "rgba(220, 38, 38, 0.50)",
      minWidth: 150,
    },
    timestampWrapper: {
      flexDirection: "row",
      // marginTop: 10,
      gap: 5,
      alignSelf: "flex-end",
      alignItems: "center",
    },
    tickIcon: {
      height: 16,
      width: 16,
      resizeMode: "contain",
    },
    receiverWrapper: {
      flexDirection: "row",
      marginTop: 8,
      // alignSelf: "flex-start",
    },
    profilePic: {
      backgroundColor: AppColors.purpleColor_9D2CF5,
      width: 32,
      height: 32,
      marginRight: 10,
      borderRadius: 100,
      alignSelf: "flex-end",
    },
    receiverChatWrapper: {
      maxWidth: "65%",
      minWidth: 150,
      paddingHorizontal: 10,
      paddingTop: 10,
      marginBottom: 4,
      borderRadius: 2,
      backgroundColor: "#FFFFFF",
      alignSelf: "flex-start",
      flexShrink: 1,
    },

    timestamp: {
      paddingTop: 10,
      opacity: 0.4,
      alignSelf: "flex-start",
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      senderChatWrapper: {
        paddingHorizontal: 8,
        paddingTop: 8,

        // flexDirection: "row",
        // gap: 10,
      },
      receiverChatWrapper: {
        paddingTop: 8,
        paddingRight: 8,
        paddingLeft: 8,
        // flexDirection: "row",
        // gap: 10,
      },
    },
    [DEVICE_SIZES.SM]: {
      senderChatWrapper: {
        paddingHorizontal: 10,
        paddingTop: 10,
        // flexDirection: "row",
        // gap: 10,
      },
      receiverChatWrapper: {
        paddingTop: 10,
        paddingRight: 10,
        paddingLeft: 10,
        // flexDirection: "row",
        // gap: 10,
      },
    },
    [DEVICE_SIZES.MD]: {
      senderChatWrapper: {
        paddingHorizontal: 12,
        paddingVertical: 10,
      },
      receiverChatWrapper: {
        padding: 10,
      },
    },
    [DEVICE_SIZES.LG]: {
      senderChatWrapper: {
        paddingHorizontal: 14,
        paddingVertical: 12,
      },
      receiverChatWrapper: {
        padding: 12,
      },
    },
    [DEVICE_SIZES.XL]: {
      senderChatWrapper: {
        paddingHorizontal: 16,
        paddingVertical: 14,
      },
      receiverChatWrapper: {
        padding: 14,
      },
    },
  }
);

export default withErrorBoundary(ChatModalMessageBubble);
